/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import Page from '../Pagination/Pagination'
import $ from 'jquery'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import SearchableCombo from '../BaseComponent/searchableCombo'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import TMS from '../BaseComponent/TMS'
import {MDBCol} from './CreateTask'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import FromToPicker from '../BaseComponent/FromToPicker'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import USER_REPORT from '../BaseComponent/USERREPORT'
import {Interval} from '../BaseComponent/Variable'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import Select from 'react-select'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'

class ManageActivity extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      defaultValueDate: true,
      loading: false,
      printInfo: [],
      lengthProviders: 0,
      planDateMin: '',
      planDateMax: '',
      list: [],
      providers: [],
      products: [],
      providerId: '',
      productId: '',
      tasks: [],
      sections: [],
      modalReject: false,
      modalAccept: false,
      fromDate: '',
      toDate: '',
      operators: [],
      personId: '',
      descriptionModal: false,
      department: [],
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: 'id_desc',
      getSort: '',
      sortData: [
        {
          name: 'انتخاب',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کاربر',
          value: 'user.name',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'دپارتمان',
          value: 'departmentTitle',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'بخش',
          value: 'sectionTitle',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'فعالیت',
          value: 'taskTitle',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تامین کننده',
          value: 'providerTitle',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'کالا',
          value: 'productTitle',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'بازه زمانی',
          value: 'taskTimeMinuteMin',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'وضعیت',
          value: 'state',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تاریخ ثبت',
          value: 'id',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'کاربر ثبت کننده',
          value: 'creator',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد',
          value: 'count',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تاریخ فعالیت',
          value: 'activityDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'زمان تخمینی',
          value: 'timeMinuteUser',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'زمان مورد تایید',
          value: 'timeMinuteOperator',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'توضیحات',
          value: 'description',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تعیین وضعیت',
          value: 'seen',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخچه',
          value: 'seen',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      arrayOfTaskId: [],
      checkAllTable: false
    }
  }

  changeOrg(e) {
    let value = e.target.value
    if (value === '') {
      this.setState({
        sections: []
      })
    } else {
      let personId = localStorage.getItem('personId')

      http
        .get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}?departmentId=${value}&personId=${personId}`, {})
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              sections: response.data.object
            })
          } else {
            this.setState({
              sections: []
            })
          }
        })
    }
  }

  getValueProvider = (providerId) => {
    if (!providerId) {
      this.setState({
        products: [],
        providerId: null
      })
    } else {
      this.setState({
        providerId
      })
      let id = providerId

      http
        .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PRODUCT}?providerId=${id}`, {
          params: {
            sortByTitle: true
          }
        })
        .then((response) => {
          if (response.data.error === null) {
            var products = response.data.object
            for (let i = 0; i < products.length; i++) {
              products[i]['value'] = products[i].productId
              products[i]['label'] = products[i].articleId + ' - ' + products[i].productName
            }
            this.setState({
              products: response.data.object
            })
          } else {
            this.setState({
              products: []
            })
          }
        })
    }
  }

  getValueProduct = (productId) => {
    if (productId === null) {
      this.setState({
        productId: ''
      })
    } else {
      this.setState({
        productId
      })
    }
  }

  getValueOperator = (personId) => {
    if (personId === null) {
      this.setState({
        personId: ''
      })
    } else {
      this.setState({
        personId
      })
    }
  }

  changeSec(e) {
    let value = e.target.value
    if (value === '') {
      this.setState({
        tasks: []
      })
    } else {
      http.get(`${TMS.TMS_MANAGE_BASE_TASK_LIST}?sectionId=${value}`, {}).then((response) => {
        if (response.data.error === null) {
          this.setState({
            tasks: response.data.object
          })
        } else {
          this.setState({
            tasks: []
          })
        }
      })
    }
  }

  loadManageReportFromQuery = (departmentId, sectionId, taskId, providerId, productId, state) => {
    let filter = {}
    if (departmentId !== '') {
      filter.departmentId = departmentId
      this.setState({
        serverDepartmentId: departmentId
      })
      let personId = localStorage.getItem('personId')

      http
        .get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}?departmentId=${departmentId}&personId=${personId}`, {})
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              sections: response.data.object
            })
          } else {
            this.setState({
              sections: []
            })
          }
        })
    }
    if (sectionId !== '') {
      filter.sectionId = sectionId
      this.setState({
        serverSectionId: sectionId
      })
      http.get(`${TMS.TMS_MANAGE_BASE_TASK_LIST}?sectionId=${sectionId}`, {}).then((response) => {
        if (response.data.error === null) {
          this.setState({
            tasks: response.data.object
          })
        } else {
          this.setState({
            tasks: []
          })
        }
      })
    }
    if (taskId !== '') {
      filter.taskId = taskId
      this.setState({
        serverTaskId: taskId
      })
    }
    if (providerId !== '') {
      filter.providerId = providerId
      let serverProvider = this.state.providers.find((item) => +item.providerId === +providerId)
      if (serverProvider) {
        this.setState({
          providerId: serverProvider
        })
      }
      http
        .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PRODUCT}?providerId=${providerId}`, {
          params: {
            sortByTitle: true,
            providerId: providerId
          }
        })
        .then((response) => {
          if (response.data.error === null) {
            let products = response.data.object
            if (productId !== '') {
              let findProductId = products.find((item) => item.productId == productId)
              if (findProductId) {
                this.setState({
                  productId: findProductId
                })
              }
            }
            for (let i = 0; i < products.length; i++) {
              products[i]['value'] = products[i].productId
              products[i]['label'] = products[i].articleId + ' - ' + products[i].productName
            }
            this.setState({
              products: response.data.object
            })
          } else {
            this.setState({
              products: []
            })
          }
        })
    }
    if (productId !== '') {
      filter.productId = productId
    }
    if (state !== '') {
      filter.state = state
      this.setState({
        serverState: state
      })
    }
    filter.sortBy = this.state.sortBy

    http
      .get(`${TMS.TMS_MANAGE_ACTIVITY_REPORT}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            list: response.data.object.result,
            countAll: response.data.object.countAll,
            loading: false,
            buttonClicked: true
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            list: [],
            countAll: 0,
            loading: false
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  getProviders = () => {
    // return http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`,{
    //     params: {
    //         sortByTitle: true,
    //         all: true
    //     }
    // }).then((response)=>{
    //     if(response.data.error==null){
    //         var provider = response.data.object;
    //         for (let i = 0; i < provider.length; i++) {
    //             provider[i]['value'] = provider[i].providerId;
    //             provider[i]['label'] =provider[i].providerId +' - '+ provider[i].title;
    //         }
    //         this.setState({
    //             providers:response.data.object
    //         })
    //     }
    //     else{
    //         this.setState({
    //             providers:[]
    //         })
    //     }
    // })
  }

  getOperators = () => {
    return http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object
        })
      }
    })
  }

  getOrganizations = () => {
    let personId = localStorage.getItem('personId')

    return http.get(`${TMS.TMS_MANAGE_BASE_ORGANIZATION_LIST}?personId=${personId}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          department: response.data.object
        })
      }
    })
  }

  componentDidMount() {
    Promise.all([this.getOrganizations(), this.getOperators()]).then(() => {
      let urlParams = new URLSearchParams(window.location.search)
      let departmentId = urlParams.get('departmentId') === null ? '' : urlParams.get('departmentId')
      let sectionId = urlParams.get('sectionId') === null ? '' : urlParams.get('sectionId')
      let taskId = urlParams.get('taskId') === null ? '' : urlParams.get('taskId')
      let state = urlParams.get('state') === null ? '' : urlParams.get('state')
      let providerId =
        urlParams.get('providerId') === null || urlParams.get('providerId') === 'null'
          ? ''
          : urlParams.get('providerId')
      let productId =
        urlParams.get('productId') === null || urlParams.get('productId') === 'null' ? '' : urlParams.get('productId')
      if (
        !(
          departmentId === '' &&
          sectionId === '' &&
          taskId === '' &&
          providerId === '' &&
          productId === '' &&
          state === ''
        )
      ) {
        this.loadManageReportFromQuery(departmentId, sectionId, taskId, providerId, productId, state)
        this.setState({
          defaultValueDate: false
        })
      }
    })

    // this.interval()

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.basketFilterComponent').slideUp()
      })
    })
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${TMS.TMS_MANAGE_ACTIVITY_REPORT}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          let res = response.data.object.result
          let arrayOfTaskId = this.state.arrayOfTaskId
          arrayOfTaskId.forEach((item) => {
            let findId = res.findIndex((r) => r.id === item.id)
            if (findId > -1) {
              res[findId].checked = true
            }
          })

          if (!exportStatus) {
            this.setState({
              list: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false,
              buttonClicked: true,
              checkAllTable: false
            })
          } else if (exportStatus) {
            this.setState({
              printInfo: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false
            })
          }
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            list: [],
            countAll: 0,
            loading: false
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }
  createFilter = (exportStatus) => {
    let filter = {}
    let sectionId = document.getElementById('sectionId').value
    let taskId = document.getElementById('taskId').value
    let departmentId = document.getElementById('departmentId').value
    let description = document.getElementById('description').value.trim()

    let state = document.getElementById('state').value
    let activityDateMin = this.state.fromDate
    let activityDateMax = this.state.toDate
    let personId = this.state.personId !== '' ? this.state.personId.personId : ''
    let providerId = this.state.providerId
    let productId = this.state.productId === '' || this.state.productId === null ? '' : this.state.productId.productId
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (sectionId !== '') {
      filter.sectionId = sectionId
    }
    if (taskId !== '') {
      filter.taskId = taskId
    }
    if (departmentId !== '') {
      filter.departmentId = departmentId
    }
    if (state !== '') {
      filter.state = state
    }
    if (activityDateMin !== '') {
      filter.activityDateMin = activityDateMin
    }
    if (activityDateMax !== '') {
      filter.activityDateMax = activityDateMax
    }
    if (personId !== '') {
      filter.personId = personId
    }
    if (providerId !== '') {
      filter.providerId = providerId
    }
    if (productId !== '') {
      filter.productId = productId
    }
    if (description !== '') {
      filter.description = description
    }
    return filter
  }

  filter() {
    let activityDateMin = this.state.fromDate
    let activityDateMax = this.state.toDate

    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((activityDateMin !== '' || activityDateMin === null) && isNaN(activityDateMin)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((activityDateMax !== '' || activityDateMax === null) && isNaN(activityDateMax)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${TMS.TMS_MANAGE_ACTIVITY_REPORT}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          console.log(response.data.object.result)
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i].timeMinuteOperator = this.convertCount(excelReport[i].timeMinuteOperator)
            excelReport[i].timeMinuteUser = this.convertCount(excelReport[i].timeMinuteUser)
            excelReport[i].count = this.convertCount(excelReport[i].count)
            excelReport[i]['activityDate'] = jMoment(excelReport[i]['activityDate']).format('jYY/jMM/jDD HH:mm')
            excelReport[i]['creationTime'] = jMoment(excelReport[i]['creationTime']).format('jYY/jMM/jDD HH:mm')
            excelReport[i]['state'] = this.convertState(excelReport[i]['state'])
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  // onResultFetched(data) {
  //     this.setState({
  //         list: data
  //     })
  // }

  changeDropDown(data) {
    this.setState({
      list: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  convertState = (state) => {
    switch (state) {
      case 100:
        return 'در انتظار'
        break
      case 10:
        return <img src={require('../../image/confirm.svg')} style={{width: '20px'}} />
        break
      case 20:
        return <img src={require('../../image/ignor.svg')} style={{width: '20px'}} />
        break
      default:
        return '-'
    }
  }

  accept = (id, timeMinuteOperator) => {
    this.setState({
      id,
      timeMinuteOperator,
      modalAccept: true
    })
    setTimeout(() => {
      document.getElementById('timeMinuteOperator').focus()
      document.getElementById('timeMinuteOperator').select()
    }, 1000)
  }

  acceptOk = () => {
    let timeMinuteOperator = document.getElementById('timeMinuteOperator').value
    if (timeMinuteOperator === '') {
      message.error('زمان مورد تایید وارد شود')
    } else {
      let data = {
        id: this.state.id,
        timeMinuteOperator
      }
      http.post(`${TMS.TMS_MANAGE_ACTIVITY_ACCEPET}`, data, {}).then((response) => {
        if (response.data.error === null) {
          this.setState({
            modalAccept: false
          })
          this.getReport(false)
          // http.get(`${TMS.TMS_MANAGE_ACTIVITY_REPORT}?export=false&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`, {}).then((response) => {
          //
          //     if (response.data.error == null) {
          //         $('.showBaseTable,.print').fadeIn();
          //         this.setState({
          //             list: response.data.object.result,
          //             buttonClicked:true,
          //             countAll : response.data.object.countAll
          //         })
          //     } else {
          //         $('.showBaseTable,.print').fadeOut();
          //     }
          // });
        }
      })
    }
  }

  reject = (id) => {
    this.setState({
      modalReject: true,
      id
    })
  }

  revert = (id) => {
    this.setState({
      id,
      modalRevert: true
    })
  }

  revertOk = () => {
    let data = {
      id: this.state.id
    }
    http.post(`${TMS.TMS_MANAGE_ACTIVITY_REVERT}`, data, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          modalRevert: false
        })
        message.success('با موفقیت انجام شد')
        this.getReport(false)
      }
    })
  }

  cancel = () => {}
  rejectOk = () => {
    let description = document.getElementById('descriptionReject').value.trim()
    let {id} = this.state
    if (description === '') {
      message.error('علت عدم تایید نوشته شود')
    } else {
      let data = {
        id,
        description
      }
      http.post(`${TMS.TMS_MANAGE_ACTIVITY_REJECT}`, data, {}).then((response) => {
        if (response.data.error === null) {
          this.setState({
            modalReject: false
          })
          message.success('عدم تایید شد')
          this.getReport(false)
        }
      })
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  statusColor = (timeMinuteUser, taskTimeMinuteMin, taskTimeMinuteMax, count) => {
    if (timeMinuteUser < taskTimeMinuteMin * count) {
      return '#d4fcc3'

      //red
    } else if (timeMinuteUser > taskTimeMinuteMax * count) {
      return '#fbd9d9'
    } else {
      return ''
    }
  }

  showDescription = (description) => {
    this.setState({
      description,
      descriptionModal: true
    })
  }

  toggleCheck = (id, checked, state) => {
    //state = 100 -> pending
    // state = 10 -> accept
    // state = 20 -> reject
    let arrayOfTaskId = this.state.arrayOfTaskId
    let list = this.state.list
    if (!checked) {
      let findId = arrayOfTaskId.find((item) => item === id)
      if (!findId) {
        if (arrayOfTaskId.length === 0) {
          arrayOfTaskId.push({
            id,
            state
          })
          let findIndex = this.state.list.findIndex((item) => item.id === id)
          if (findIndex > -1) {
            this.state.list[findIndex].checked = !checked
          }
        } else if (arrayOfTaskId.length > 0) {
          let findFirstElementArrayOfTaskId = arrayOfTaskId[0]
          if (state === findFirstElementArrayOfTaskId.state) {
            arrayOfTaskId.push({
              id,
              state
            })
            let findIndex = this.state.list.findIndex((item) => item.id === id)
            if (findIndex > -1) {
              this.state.list[findIndex].checked = !checked
            }
          } else {
            message.error(`موارد انتخاب شده باید همگی از یک نوع باشند`)
          }
        }
      }
      this.setState(
        {
          list,
          arrayOfTaskId
        },
        () => {}
      )
    } else {
      let index = arrayOfTaskId.findIndex((i) => i.id === id)
      let findIndex = this.state.list.findIndex((item) => item.id === id)
      if (findIndex > -1) {
        this.state.list[findIndex].checked = !checked
      }
      if (index > -1) {
        arrayOfTaskId.splice(index, 1)
        this.setState(
          {
            arrayOfTaskId,
            list
          },
          () => {}
        )
      }
    }
  }

  convertCount = (count) => {
    if (count !== null) {
      return count.toFixed(1).replace('.0', '')
    } else {
      return ''
    }
  }

  multipleOperation = () => {
    let multipleOperation = document.getElementById('multipleOperation').value
    if (multipleOperation === '') {
      message.error('نوع عملیات را انتخاب کنید')
    } else if (this.state.arrayOfTaskId.length === 0) {
      message.error('حداقل یک مورد باید انتخاب شود')
    } else {
      if (multipleOperation === 'accept') {
        let arrayOfTaskId = this.state.arrayOfTaskId
        let ids = []
        arrayOfTaskId.forEach((item) => {
          ids.push(item.id)
        })
        let data = {
          ids
        }
        let findUnRelatedTask = arrayOfTaskId.find((item) => item.state !== 100)
        if (!findUnRelatedTask) {
          http.post(`tms/manage/activity/multi/accept`, data, {}).then((res) => {
            if (res.data.error === null) {
              this.setState(
                {
                  arrayOfTaskId: []
                },
                () => {
                  message.success('با موفقیت انجام شد')
                  this.getReport(false)
                }
              )
            }
          })
        } else {
          message.error('برای تایید فعالیت ها باید فعالیت هایی انتخاب شود که وضعیت در انتظار دارند')
        }
      } else if (multipleOperation === 'reject') {
        let arrayOfTaskId = this.state.arrayOfTaskId
        let ids = []
        arrayOfTaskId.forEach((item) => {
          ids.push(item.id)
        })
        let data = {
          ids
        }
        let findUnRelatedTask = arrayOfTaskId.find((item) => item.state !== 100)
        if (!findUnRelatedTask) {
          http.post(`tms/manage/activity/multi/reject`, data, {}).then((res) => {
            if (res.data.error === null) {
              this.setState(
                {
                  arrayOfTaskId: []
                },
                () => {
                  message.success('با موفقیت انجام شد')
                  this.getReport(false)
                }
              )
            }
          })
        } else {
          message.error('برای عدم تایید فعالیت ها باید فعالیت هایی انتخاب شود که وضعیت در انتظار دارند')
        }
      } else if (multipleOperation === 'revert') {
        let arrayOfTaskId = this.state.arrayOfTaskId
        let ids = []
        arrayOfTaskId.forEach((item) => {
          ids.push(item.id)
        })
        let data = {
          ids
        }
        let findUnRelatedTask = arrayOfTaskId.find((item) => item.state === 10 || item.state === 20)
        if (findUnRelatedTask) {
          http.post(`tms/manage/activity/multi/revert`, data, {}).then((res) => {
            if (res.data.error === null) {
              this.setState(
                {
                  arrayOfTaskId: []
                },
                () => {
                  message.success('با موفقیت انجام شد')
                  this.getReport(false)
                }
              )
            }
          })
        } else {
          message.error(
            'برای برگشت دادن فعالیت ها باید فعالیت هایی انتخاب شوند که در وضعیت تایید یا عدم تایید قرار دارند'
          )
        }
      }
    }
  }

  selectAllTable = () => {
    this.setState(
      {
        checkAllTable: !this.state.checkAllTable
      },
      () => {
        let checkAllTask = document.getElementById('checkAllTask').value
        //state = 100 -> pending
        // state = 10 -> accept
        // state = 20 -> reject
        let arrayOfTaskId = this.state.arrayOfTaskId
        let list = this.state.list
        if (this.state.checkAllTable) {
          if (checkAllTask === 'accept') {
            list.forEach((item) => {
              if (item.state === 10) {
                if (arrayOfTaskId.length === 0) {
                  item.checked = true
                  arrayOfTaskId.push({
                    id: item.id,
                    state: item.state
                  })
                  this.setState(
                    {
                      list,
                      arrayOfTaskId
                    },
                    () => {}
                  )
                } else if (arrayOfTaskId.length > 0) {
                  let findFirstElementArrayOfTaskId = arrayOfTaskId[0]
                  list.forEach((item, index) => {
                    if (list[index].state === findFirstElementArrayOfTaskId.state) {
                      item.checked = true
                      arrayOfTaskId.push({
                        id: item.id,
                        state: item.state
                      })
                      this.setState(
                        {
                          list,
                          arrayOfTaskId
                        },
                        () => {}
                      )
                    }
                  })
                }
              }
            })
          } else if (checkAllTask === 'reject') {
            list.forEach((item) => {
              if (item.state === 20) {
                if (arrayOfTaskId.length === 0) {
                  item.checked = true
                  arrayOfTaskId.push({
                    id: item.id,
                    state: item.state
                  })
                  this.setState(
                    {
                      list,
                      arrayOfTaskId
                    },
                    () => {}
                  )
                } else if (arrayOfTaskId.length > 0) {
                  let findFirstElementArrayOfTaskId = arrayOfTaskId[0]
                  list.forEach((item, index) => {
                    if (list[index].state === findFirstElementArrayOfTaskId.state) {
                      item.checked = true
                      arrayOfTaskId.push({
                        id: item.id,
                        state: item.state
                      })
                      this.setState(
                        {
                          list,
                          arrayOfTaskId
                        },
                        () => {}
                      )
                    }
                  })
                }
              }
            })
          } else if (checkAllTask === 'pending') {
            list.forEach((item) => {
              if (item.state === 100) {
                if (arrayOfTaskId.length === 0) {
                  item.checked = true
                  arrayOfTaskId.push({
                    id: item.id,
                    state: item.state
                  })
                  this.setState(
                    {
                      list,
                      arrayOfTaskId
                    },
                    () => {}
                  )
                } else if (arrayOfTaskId.length > 0) {
                  let findFirstElementArrayOfTaskId = arrayOfTaskId[0]
                  list.forEach((item, index) => {
                    if (list[index].state === findFirstElementArrayOfTaskId.state) {
                      item.checked = true
                      arrayOfTaskId.push({
                        id: item.id,
                        state: item.state
                      })
                      this.setState(
                        {
                          list,
                          arrayOfTaskId
                        },
                        () => {}
                      )
                    }
                  })
                }
              }
            })
          }
        } else {
          list.forEach((item) => {
            item.checked = false
          })
          arrayOfTaskId = []
          this.setState({
            list,
            arrayOfTaskId
          })
        }
      }
    )
  }

  showPending = () => {
    let arrayOfTaskId = this.state.arrayOfTaskId
    if (arrayOfTaskId.length > 0) {
      if (arrayOfTaskId[0].state === 100) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }
  showAccept = () => {
    let arrayOfTaskId = this.state.arrayOfTaskId
    if (arrayOfTaskId.length > 0) {
      if (arrayOfTaskId[0].state === 10) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }
  showReject = () => {
    let arrayOfTaskId = this.state.arrayOfTaskId
    if (arrayOfTaskId.length > 0) {
      if (arrayOfTaskId[0].state === 20) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'بخش',
      'فعالیت',
      'تامین کننده',
      'کالا',
      'وضعیت',
      'تاریخ ثبت',
      'کاربر ثبت کننده',
      'تعداد',
      'تاریخ فعالیت',
      'زمان تخمینی',
      'توضیحات'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش فعالیت ها"
              headerColSpan={11}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={6}
              centerColSpan={2}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.sectionTitle}</td>
                  <td>{item.taskTitle}</td>
                  <td>{item.providerTitle}</td>
                  <td>{item.productTitle}</td>
                  <td>{this.convertState(item.state)}</td>
                  <td>{jMoment(item.creationTime).format('jYYYY/jMM/jDD')}</td>
                  <td>{item.creator.name}</td>
                  <td>{this.convertCount(item.count)}</td>
                  <td>{jMoment(item.activityDate).format('jYYYY/jMM/jDD')}</td>
                  <td>{this.convertCount(item.timeMinuteUser) + ' دقیقه '}</td>
                  <td>{item.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش فعالیت ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'user'}
                field={'user.name'}
                title={'کاربر'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'departmentTitle'}
                field={'departmentTitle'}
                title={'دپارتمان'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'sectionTitle'}
                field={'sectionTitle'}
                title={'بخش'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'taskTitle'}
                field={'taskTitle'}
                title={'فعالیت'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'providerTitle'}
                field={'providerTitle'}
                title={'تامین کننده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'productTitle'}
                field={'productTitle'}
                title={'کالا'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'taskTimeMinuteMin'}
                field={'taskTimeMinuteMin'}
                title={'بازه زمانی از'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'taskTimeMinuteMax'}
                field={'taskTimeMinuteMax'}
                title={'بازه زمانی تا'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'state'}
                field={'state'}
                title={'وضعیت'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'creationTime'}
                field={'creationTime'}
                title={'تاریخ ثبت'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'creator.name'}
                field={'creator.name'}
                title={'کاربر ثبت کننده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'count'}
                field={'count'}
                title={'تعداد'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'activityDate'}
                field={'activityDate'}
                title={'تاریخ فعالیت'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteUser'}
                field={'timeMinuteUser'}
                title={'زمان تخمینی'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteOperator'}
                field={'timeMinuteOperator'}
                title={'زمان مورد تایید'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'description'}
                field={'description'}
                title={'توضیحات'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>مدیریت فعالیت ها</li>
            <li>تایید فعالیت ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel=" تاریخ فعالیت از"
                  toLabel=" تاریخ فعالیت تا"
                  defaulValue={this.state.defaultValueDate}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    دپارتمان
                  </label>
                  <select
                    className="custom-select"
                    onChange={this.changeOrg.bind(this)}
                    name="departmentId"
                    id="departmentId"
                  >
                    <option value="">------</option>
                    {this.state.department.map((item, index) => (
                      <option
                        selected={this.state.serverDepartmentId == item.id ? true : false}
                        value={item.id}
                        key={index}
                      >
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    بخش
                  </label>
                  <select
                    className="custom-select"
                    onChange={this.changeSec.bind(this)}
                    name="sectionId"
                    id="sectionId"
                  >
                    <option value="">------</option>
                    {this.state.sections.map((item, index) => (
                      <option
                        selected={this.state.serverSectionId == item.id ? true : false}
                        value={item.id}
                        key={index}
                      >
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    فعالیت
                  </label>
                  <select className="custom-select" name="taskId" id="taskId">
                    <option value="">------</option>
                    {this.state.tasks.map((item, index) => (
                      <option selected={this.state.serverTaskId == item.id ? true : false} value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={this.getValueProvider}
                  />
                  {/* <label className={'font-weight-bold'}>تامین کننده</label>
                                    <Select
                                        options={this.state.providers}
                                        isClearable={true}
                                        placeholder={'------'}
                                        value={this.state.providerId}
                                        onChange={this.getValueProvider}
                                    />
                                     */}
                </div>
                <div className="formComponent">
                  <label className={'font-weight-bold'}>کالا</label>

                  <Select
                    options={this.state.products}
                    isClearable={true}
                    placeholder={'------'}
                    value={this.state.productId}
                    onChange={this.getValueProduct}
                  />
                  {/*<SearchableCombo*/}
                  {/*    options={this.state.products}*/}
                  {/*    getValueCombo={this.getValueProduct}*/}
                  {/*    lableText='کالا'*/}
                  {/*    placeholder='------'*/}
                  {/*    isClearable={true}*/}
                  {/*    isMulti={false}*/}
                  {/*    className='font-weight-bold'*/}
                  {/*/>*/}
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.operators}
                    getValueCombo={this.getValueOperator}
                    lableText="کاربران"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    وضعیت
                  </label>
                  <select className="custom-select" name="state" id="state">
                    <option value="">------</option>
                    <option selected={this.state.serverState == 100 ? true : false} value={100}>
                      در انتظار
                    </option>
                    <option selected={this.state.serverState == 10 ? true : false} value={10}>
                      تایید شده
                    </option>
                    <option selected={this.state.serverState == 20 ? true : false} value={20}>
                      تایید نشده
                    </option>
                  </select>
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    توضیحات
                  </label>
                  <textarea id="description" className="form-control" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
              {this.state.list.length !== 0 && (
                <div className="container-fluid">
                  <hr />
                  <div className="row">
                    <div className="col-2 p-2">
                      <div>
                        <label>اعمال دسته جمعی</label>
                        <select id="multipleOperation" className="form-control">
                          <option value="">------</option>
                          <option value="accept">تایید</option>
                          <option value="reject">عدم تایید</option>
                          <option value="revert">برگشت</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-2 p-2">
                      <div>
                        <label className="invisible">اطلاع رسانی</label>
                        <span
                          onClick={() => this.multipleOperation()}
                          style={{background: '#f7a732', border: '1px solid #f7a732'}}
                          className="searchCustommer"
                        >
                          اعمال
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="p-2 d-flex flex-row justify-content-center align-items-center  align-content-end">
                      {this.state.checkAllTable ? (
                        <img
                          width={20}
                          onClick={() => this.selectAllTable()}
                          style={{marginTop: '25px'}}
                          src={require('../../image/checkbox.svg')}
                        />
                      ) : (
                        <img
                          width={20}
                          onClick={() => this.selectAllTable()}
                          style={{marginTop: '25px'}}
                          src={require('../../image/unCheckBox.png')}
                        />
                      )}
                      <label className="small mx-2" style={{marginTop: 35}}>
                        انتخاب همه
                      </label>
                    </div>
                    <div className="p-2">
                      <label className="invisible">انتخاب همه موارد این صفحه بر مبنای :‌</label>
                      <select id="checkAllTask" className="form-control">
                        {this.showPending() ? <option value="pending">فعالیت های در انتظار</option> : null}
                        {this.showAccept() ? <option value="accept">فعالیت های تایید شده</option> : null}
                        {this.showReject() ? <option value="reject">فعالیت های تایید نشده</option> : null}
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                <tbody>
                  {this.state.list.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: this.statusColor(
                          item.timeMinuteUser,
                          item.taskTimeMinuteMin,
                          item.taskTimeMinuteMax,
                          item.count
                        )
                      }}
                    >
                      <td>
                        <span onClick={() => this.toggleCheck(item.id, item.checked, item.state)}>
                          {item.checked && <img src={require('../../image/checkbox.svg')} />}
                          {!item.checked ? <img src={require('../../image/unCheckBox.png')} /> : null}
                        </span>
                      </td>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{item.user !== null && item.user.name}</td>
                      <td>{item.departmentTitle}</td>
                      <td>{item.sectionTitle}</td>
                      <td>{item.taskTitle}</td>
                      <td>{item.providerTitle}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: item.articleId})}>
                          {item.productTitle}
                        </a>
                      </td>
                      <td>{item.taskTimeMinuteMin + ' - ' + item.taskTimeMinuteMax + ' دقیقه '}</td>
                      <td>{this.convertState(item.state)}</td>
                      <td>{jMoment(item.creationTime).format('jYYYY/jMM/jDD')}</td>
                      <td>{item.creator.name}</td>
                      <td>{this.convertCount(item.count)}</td>
                      <td>{jMoment(item.activityDate).format('jYYYY/jMM/jDD')}</td>
                      <td>{this.convertCount(item.timeMinuteUser) + ' دقیقه '}</td>
                      <td>{item.state === 10 && this.convertCount(item.timeMinuteOperator) + ' دقیقه '}</td>

                      <td>
                        {item.description !== null && (
                          <img
                            style={{cursor: 'pointer'}}
                            src={require('../../image/eye.svg')}
                            title={item.description}
                            onClick={() => this.showDescription(item.description)}
                          />
                        )}
                      </td>
                      <td style={{minWidth: '130px'}}>
                        {item.state === 100 ? (
                          <>
                            <button
                              style={{width: '80%'}}
                              className="btn btn-sm btn-success small"
                              onClick={() => this.accept(item.id, item.timeMinuteOperator)}
                            >
                              <span className="">تایید</span>
                            </button>
                            <button
                              style={{width: '80%'}}
                              onClick={() => this.reject(item.id)}
                              className="btn btn-sm btn-danger small"
                            >
                              <span className="">عدم تایید</span>
                            </button>
                          </>
                        ) : (
                          <button
                            style={{width: '80%', color: '#000'}}
                            title={'بازنشانی'}
                            onClick={() => this.revert(item.id)}
                            className="btn btn-sm btn-warning small"
                          >
                            <span className="">بازنشانی</span>
                          </button>
                        )}
                      </td>
                      <td>
                        <Link to={`/tms/manageTask/history/${item.id}`} target="_blank">
                          <img src={require('../../image/details.svg')} />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalReject} toggle={this.cancel} size="sm">
          <ModalHeader toggle={this.cancel}>علت عدم تایید</ModalHeader>
          <ModalBody>
            <div className="formComponent">
              <label>علت عدم تایید</label>
              <textarea id="descriptionReject" className="form-control" />
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.rejectOk}>
              عدم تایید
            </button>
            <button
              className="cancelBtnModal"
              onClick={() =>
                this.setState({
                  modalReject: false
                })
              }
            >
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalRevert} toggle={() => this.setState({modalRevert: false})} size="sm">
          <ModalHeader toggle={() => this.setState({modalRevert: false})}>برگشت</ModalHeader>
          <ModalBody className="text-center font-weight-bold">
            <p>آیا از لغو تایید اطمینان دارید؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.revertOk}>
              لغو تایید
            </button>
            <button
              className="cancelBtnModal"
              onClick={() =>
                this.setState({
                  modalRevert: false
                })
              }
            >
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalAccept} toggle={this.cancel} size="sm">
          <ModalHeader toggle={this.cancel} />
          <ModalBody>
            <div className="">
              <label className="font-weight-bold">زمان مورد تایید</label>
              <input
                type="number"
                id="timeMinuteOperator"
                className="form-control numberText"
                defaultValue={this.state.timeMinuteOperator}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.acceptOk}>
              تایید کردن
            </button>
            <button
              className="cancelBtnModal"
              onClick={() =>
                this.setState({
                  modalAccept: false
                })
              }
            >
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.descriptionModal} toggle={() => this.setState({descriptionModal: false})} size="sm">
          <ModalHeader toggle={() => this.setState({descriptionModal: false})}>مشاهده توضیحات</ModalHeader>
          <ModalBody>
            <div className="">
              <p className="text-center font-weight-bold">{this.state.description}</p>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              className="cancelBtnModal"
              onClick={() =>
                this.setState({
                  descriptionModal: false
                })
              }
            >
              بستن
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default ManageActivity
